// Checks to determine whether to show a notification that shows skipping forward is disabled
export const getShouldShowVideoSkippingDisabledNotification = (
  barFractionOffset: number,
  duration: number | null | undefined,
  shouldDisableSkippingForward: boolean,
  learnerMaxVideoProgressInSeconds: number
): boolean => {
  return (
    // If a learner clicks on a video time that they haven't watched yet, a notification that shows skipping forward
    // is disabled will show up
    shouldDisableSkippingForward && barFractionOffset * (duration || 0) > learnerMaxVideoProgressInSeconds
  );
};

// Checks to determine whether scrubbing forward is allowed based on the learner's progress
export const getIsScrubbingAllowed = (
  barFractionOffset: number,
  duration: number | null | undefined,
  shouldDisableSkippingForward: boolean,
  learnerMaxVideoProgressInSeconds: number
): boolean => {
  return (
    // Allow learners (by returning true) to be able to skip forward if shouldDisableSkippingForward is false
    // or if they area of the video the learner is trying to skip to is within the time they've already watched
    !shouldDisableSkippingForward || barFractionOffset * (duration ?? 0) <= learnerMaxVideoProgressInSeconds
  );
};

export const fractionToWholeNumber = (fraction: number) => {
  return fraction * 100;
};

export const formatFraction = (fraction: number) => {
  return `${(Math.floor(fraction * 10000) / 100).toFixed(2)}%`;
};
